import { DivisionListModel, DivisionModel, DivisionPayoutPolicyRM, DivisionProfileListResponse } from "@herbjoy/apex-api-models";
import { IHttpService } from "angular";

/** An enum of divisions that have unique behaviour defined. */
export const DivisionEnum = {
    RoadShow: 29,
    Dtv: 31,
    Rogers: 35
}

export class DivisionService {
    divisionIDs = DivisionEnum;
    constructor(private $http: IHttpService, private apexApiUrl: string) {
        'ngInject'
    }

    retrieveDivisions(query?) {
        return this.$http<DivisionListModel[]>({
            method: "GET",
            headers: { Accept: "application/json" },
            url: this.apexApiUrl + "divisions",
            params: query
        })
            .then(response => {
                return response.data;
            });
    }

    retrieveDivision(divisionID) {
        return this.$http<DivisionModel>({
            method: "GET",
            headers: { Accept: "application/json" },
            url: this.apexApiUrl + "v2/divisions/" + divisionID
        }).then(response => {
            return response.data;
        });
    }

    retrieveIcdOfficeDivisions(icdOfficeID) {
        return this.$http<DivisionListModel>({
            method: "GET",
            url: this.apexApiUrl + "icd-offices/" + icdOfficeID + "/divisions"
        }).then(response => {
            return response.data;
        });
    }

    createDivision(request) {
        return this.$http<number>({
            method: "POST",
            url: this.apexApiUrl + "divisions",
            data: request,
            headers: { "Content-Type": "application/json", Accept: "application/json" }
        })
            .then(response => {
                return response.data;
            });
    }

    updateDivision(divisionID, request) {
        return this.$http({
            method: "PUT",
            url: this.apexApiUrl + "divisions/" + divisionID,
            data: request,
            headers: { "Content-Type": "application/json", Accept: "application/json" }
        }).then(() => {
            return this.retrieveDivision(divisionID);
        });
    }


    deleteDivision(divisionID) {
        return this.$http({
            method: "DELETE",
            url: this.apexApiUrl + "divisions/" + divisionID
        });
    }

    retrieveDivisionProfiles(query?) {
        return this.$http<DivisionProfileListResponse[]>({
            method: "GET",
            url: this.apexApiUrl + "division-profiles",
            params: query,
            headers: { Accept: "application/json" }
        }).then(response => {
            return response.data;
        });
    }

    updateDivisionProfilePayrollPolicyHistory(divisionProfileID, request) {
        return this.$http<DivisionPayoutPolicyRM[]>({
            method: "PUT",
            url: this.apexApiUrl + "division-profiles/" + divisionProfileID + "/payroll-policy-history",
            data: request,
            headers: { "Content-Type": "application/json" }
        });
    }
}
